import { render, staticRenderFns } from "./Finished.vue?vue&type=template&id=b033cca2&scoped=true&"
import script from "./Finished.vue?vue&type=script&lang=js&"
export * from "./Finished.vue?vue&type=script&lang=js&"
import style0 from "./Finished.vue?vue&type=style&index=0&id=b033cca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b033cca2",
  null
  
)

export default component.exports